import React from 'react'
import './missing-student-rate-popup.css'

const MissingStudentRatePopup = (props) => {

    const tryToClose = (id) => {
        if(id === 'missing-student-rate-popup__wrapper') {
            props.setMissingRatesPopup(false)
        }
    }
    return(
        <div className='missing-student-rate-popup__wrapper' id='missing-student-rate-popup__wrapper' onClick={(e) => tryToClose(e.target.id)}>
            <div className='missing-student-rate-popup'>
                <h3>Empty Student Rates</h3>
                <div>The students rates are set to 0. Please add rates before closing the family.</div>
            </div>
        </div>
    )
}
export default MissingStudentRatePopup